/**
 * Auto-reload on stale chunk errors.
 *
 * After a new deploy the old hashed JS chunks no longer exist on the server.
 * If a user's browser still has cached HTML referencing old chunks, dynamic
 * imports fail with "Failed to fetch dynamically imported module".
 *
 * This handler detects that specific error and does a single hard reload
 * so the browser fetches fresh HTML + new chunks.  A sessionStorage flag
 * prevents infinite reload loops.
 */

const RELOAD_KEY = 'chunk-reload';

export function installChunkReloadHandler() {
  window.addEventListener('error', (e) => {
    const msg = e.message ?? '';
    if (
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed')
    ) {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
      }
    }
  });

  // Also catch unhandled promise rejections (dynamic import returns a promise)
  window.addEventListener('unhandledrejection', (e) => {
    const msg = e.reason?.message ?? '';
    if (
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed')
    ) {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
      }
    }
  });

  // Clear the flag on successful load so future deploys can trigger reload again
  sessionStorage.removeItem(RELOAD_KEY);
}
